var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"live"},[_c('iframe',{staticStyle:{"border":"0","width":"100%","height":"100%","over-flow":"hidden"},attrs:{"id":"iframe","src":_vm.src,"frameborder":"0","allowfullscreen":"true","allow":"microphone; camera"}})])}
var staticRenderFns = []

export { render, staticRenderFns }